import { IdName } from '@shared/models/id-name';

export interface ImplantsViewDataRxApi {
	ImplantManufacturerId?: string;
	ImplantManufacturerName?: string;
	ImplantConnectionId?: string;
	ImplantConnectionName?: string;
	ImplantPlatformId?: string;
	ImplantPlatformName?: string;
	ScanBodyId?: string;
	ScanBodyName?: string;
	PartNumber?: string;
	PartManufacturerName?: string;
	LibrarySuppliers?: string[];
}

/**
 * Extracts V1-compatible form values from ImplantsViewData for display in the old tooth editor.
 * Used when the Rx was created via the intuitive flow (ImplantTypeID is null, ImplantsViewData is set).
 */
export function extractV1ImplantFieldsFromImplantsViewData(data: ImplantsViewDataRxApi | null | undefined): {
	scanBodyManufacturer: IdName | null;
	implantManufacturer: IdName | null;
	implantTypeScanBody: IdName | null;
} {
	if (!data?.ImplantManufacturerName) {
		return { scanBodyManufacturer: null, implantManufacturer: null, implantTypeScanBody: null };
	}

	return {
		scanBodyManufacturer: data.PartManufacturerName
			? { Id: data.PartManufacturerName, Name: data.PartManufacturerName }
			: null,
		implantManufacturer: { Id: data.ImplantManufacturerId ?? '', Name: data.ImplantManufacturerName },
		implantTypeScanBody: data.ScanBodyName
			? { Id: data.ScanBodyId ?? '', Name: data.ScanBodyName }
			: null
	};
}
